import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
const DEFAULT_DURATION = 1500;

// Shows on mount, hides after `duration`. reveal() shows it again and restarts
// the timer. held=true keeps it hidden and stops the timer.
const useTemporaryReveal = t0 => {
  const $ = _c(10);
  const {
    duration: t1,
    held: t2
  } = t0;
  const duration = t1 === undefined ? DEFAULT_DURATION : t1;
  const held = t2 === undefined ? false : t2;
  const [isRevealed, setIsRevealed] = useState(true);
  const timeoutRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const clear = t3;
  let t4;
  if ($[1] !== duration) {
    t4 = () => {
      clear();
      setIsRevealed(true);
      timeoutRef.current = setTimeout(() => setIsRevealed(false), duration);
    };
    $[1] = duration;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const reveal = t4;
  let t5;
  let t6;
  if ($[3] !== held || $[4] !== reveal) {
    t5 = () => {
      if (held) {
        clear();
        return;
      }
      reveal();
      return clear;
    };
    t6 = [clear, held, reveal];
    $[3] = held;
    $[4] = reveal;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  const t7 = isRevealed && !held;
  let t8;
  if ($[7] !== reveal || $[8] !== t7) {
    t8 = {
      isRevealed: t7,
      reveal
    };
    $[7] = reveal;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
export default useTemporaryReveal;